import { render, staticRenderFns } from "./TrocaEmpresaSidebar.vue?vue&type=template&id=5e039592&"
import script from "./TrocaEmpresaSidebar.vue?vue&type=script&lang=js&"
export * from "./TrocaEmpresaSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports